import useEffect from '@hooks/useEffect'
import isEqual from 'lodash/isEqual'

export default function SetValueField(props) {
  const {onChange, value, setValue} = props
  useEffect(
    () => {
      if (isEqual(value, setValue)) return
      onChange(setValue)
    },
    [value, setValue]
  )

  return null
}
